module.exports = __webpack_public_path__ + "media/images/badges/akt/milestone-0-Inactive-AKT-23603bd68f9fcc3839b1415083cbd426.png";